/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CtTurnOverRatio = {
    CT505: 'CT505',
    CT755: 'CT755',
    CT1005: 'CT1005',
    CT1505: 'CT1505',
    CT2005: 'CT2005',
    CT3005: 'CT3005',
    CT4005: 'CT4005',
    CT5005: 'CT5005',
    CT6005: 'CT6005',
    CT8005: 'CT8005',
    CT10005: 'CT10005',
    CT12005: 'CT12005',
    CT12505: 'CT12505',
    CT15005: 'CT15005',
    CT16001: 'CT16001',
    CT16005: 'CT16005',
    CT17255: 'CT17255',
    CT20005: 'CT20005',
    CT25005: 'CT25005',
    CT30005: 'CT30005',
} as const;
export type CtTurnOverRatio = typeof CtTurnOverRatio[keyof typeof CtTurnOverRatio];

